import { useClipboard } from "@/hooks/use-clipboard";
import styles from "./styles/share-cover-button.module.scss";
import React from "react";
import { SharedCoverData, useSharedCover } from "@/hooks/use-shared-cover";
import { useMobile } from "@/hooks/use-responsive";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { getShareGeneratedCoverMessage } from "@/components/modal/share-social-media-modal/share-social-media-messages.data";
import { setSocialsModalShowKey } from "@/components/pages/shared-cover/utils/share-cover-session-storage";
import { FeatureType } from "@/app/(home)/shared/[featureType]/[id]/page";
import { useLoadingPage } from "@/components/pages/loading/hooks/useLoadingPage";

interface ShareCoverButtonProps {
  url: string;
  featureType: FeatureType;
  contentId?: string;
  sharedCoverData?: SharedCoverData;
  children: React.ReactNode;
}

/**
 Share cover button to generate share url or just copy to clipboard url
 @param {ShareCoverButtonProps} props - Component props
 @param {string} [props.url] - If convertId  added to component then button will generate and add to db shared cover.
  Set Url of already generated voice and sharedCoverData or url to .mp3 file with convertId
 */
const ShareCoverButton = ({
  featureType,
  contentId,
  url,
  sharedCoverData,
  children,
}: ShareCoverButtonProps) => {
  const { isMobile } = useMobile();
  const { showModal } = useGlobalModalContext();
  const { copyToClipboard } = useClipboard();
  const { shareContent } = useSharedCover();
  const { openLoadingPage } = useLoadingPage();

  const handleClick = async () => {
    if (contentId) {
      try {
        const decodedUrl = decodeURIComponent(url);

        if (isMobile) {
          const windowReference = openLoadingPage();
          const sharedCoverUrl = await shareContent(
            featureType,
            contentId,
            decodedUrl,
          );
          setSocialsModalShowKey();
          windowReference?.location.replace(sharedCoverUrl);
          return;
        }

        const sharedCoverUrl = await shareContent(
          featureType,
          contentId,
          decodedUrl,
        );
        await copyToClipboard(sharedCoverUrl, false);
        setSocialsModalShowKey();
        window.open(sharedCoverUrl, "_blank");
      } catch (error) {
        console.error("Sharing failed:", error);
      }
    } else {
      await copyToClipboard(url, false);
      if (sharedCoverData?.metadata) {
        showModal({
          type: "share_social_media_modal",
          props: {
            url: url,
            sharedMessageTitle: getShareGeneratedCoverMessage(
              sharedCoverData.metadata.modelName,
              sharedCoverData.coverFileName,
            ),
          },
        });
      }
    }
  };

  return (
    <button className={styles.button} onClick={handleClick}>
      {children}
    </button>
  );
};

export default ShareCoverButton;
